import { isNotDefined } from '@sgme/fp';
import { CutOffResponse } from 'apiConnector/secondary-market/cp-order/model';
import type { FormatDateOptions } from 'react-intl';

export const formatDatetimeWithTimezone = (
  cutOff: CutOffResponse | undefined,
  formatTime: (date: string, options?: FormatDateOptions) => string,
) => {
  if (isNotDefined(cutOff)) {
    return '';
  }
  const time = formatTime(cutOff.nextCutOff, cutOff.zoneId ? { timeZone: cutOff.zoneId } : undefined);
  return cutOff.zoneId ? `${time} (${cutOff.zoneId})` : time;
};
